// ============================================================
// 运行配置
//   数据源：VUE_APP_DATA_SOURCE = 'real'（对接后端）| 'mock'（本地假数据）
//   后端地址：VUE_APP_API_BASE（部署时在托管平台配置环境变量即可，无需改代码）
//   本地开发不配环境变量时，回退到 http://127.0.0.1:3000
// ============================================================
export const DATA_SOURCE = process.env.VUE_APP_DATA_SOURCE || 'real'

export const BASE_URL = process.env.VUE_APP_API_BASE || 'http://127.0.0.1:3000'

// 供页面内拼接详情链接使用（原项目里散落的硬编码地址统一走这里）
export const SITE_URL = process.env.VUE_APP_SITE_URL || (typeof window !== 'undefined' ? window.location.origin : '')
